import React, { Component } from "react";
import "../../../styles/pages/projects/ProjectHeader.css";

export default class ProjectHeader extends Component {
  render() {
    var splitTitle = this.props.title.split(" ");
    var renderTitle = splitTitle.map((word, index) => (
      <div className={`word-container ${this.props.title}`} key={index}>
        <div className={`word ${this.props.title}`}>{word}</div>
      </div>
    ));

    var renderContributions = this.props.contributions.map((cont, index) => (
      <div className="overflow-container" key={index}>
        <div className="g-tiny-text cont">{cont}</div>
      </div>
    ));

    return (
      <div className={`ProjectHeader gutters ${this.props.title}`}>
        {/* The Title */}
        <div className="title-container on-scroll-anim">
          {renderTitle}
          <div className="g-tiny-text">
            <b>Year:</b>
            {this.props.year}
          </div>
        </div>

        {/* The Story */}
        <div className="story-container on-scroll-anim">
          {/* The Section Overview */}
          <div className="section-overview-container">
            <div className="overflow-container">
              <div className="g-tiny-text the-story">The Story</div>
            </div>
            <div className="horizontal-line" />
            {renderContributions}
          </div>

          {/* The Section Description */}
          <div className="description g-sub-text">{this.props.description}</div>
        </div>

        {/* Link To The Site */}
        <a
          className="g-tiny-text on-scroll-anim website-link g-button"
          href={this.props.projectLink}
          rel="noopener noreferrer"
          target="_blank"
        >
          Visit Website &#xbb;
        </a>
      </div>
    );
  }
}
